import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { BASE_SPINDLE_BE_URL } from 'utils/constants';
import { USER_LOCAL_STORAGE_KEY } from 'contexts/auth';

const httpLink = createHttpLink({
  uri: `${BASE_SPINDLE_BE_URL}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const accessToken = sessionStorage.getItem('accessToken');

  const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY));

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : '',
      'x-site-context': user
        ? JSON.stringify({
            date: new Date().toISOString(),
            channel: 12,
            account: user?.accountId,
            stage: 'sandbox',
          })
        : undefined,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
